import * as React from 'react'
import * as clsx from 'clsx'
import { ModalWithImageWrapper } from '@modals/modal-with-image-wrapper'
import { NotificationMessage, NotificationMessageVariant } from '@models/notification-messages'
import { BaseModalProps } from '@modals/types'

const MessageColor = {
  [NotificationMessageVariant.ERROR]: 'text-danger',
  [NotificationMessageVariant.MESSAGE]: 'text-darker-gray',
}

interface Props extends BaseModalProps {
  message: NotificationMessage
}

export const NotificationMessageModal = ({ message, toggleIsVisible }: Props): JSX.Element => (
  <ModalWithImageWrapper>
    <div className="ps-xl-5 py-5 container-xl">
      {message?.subtitle !== null && (
        <h3
          className={clsx(
            'fw-bold font-size-xl mb-3',
            MessageColor[message?.variant || NotificationMessageVariant.MESSAGE],
          )}
        >
          {message?.subtitle || ''}
        </h3>
      )}
      {message?.message && (
        <span className="fw-semi-bold d-block text-darker-gray font-size-lg">{message.message}</span>
      )}
      <button className="btn btn-outline-secondary mt-4 w-75 fw-bold" onClick={toggleIsVisible}>
        Gotowe
      </button>
    </div>
  </ModalWithImageWrapper>
)
